import { ReactNode } from 'react';
import { Table } from 'antd';
import type { ColumnsType, TablePaginationConfig, TableProps } from 'antd/es/table';
import styles from './CardTable.module.scss';

interface CardTableProps<T extends object> {
  title: string;
  columns: ColumnsType<T>;
  dataSource: T[];
  rowKey: TableProps<T>['rowKey'];
  rowSelection?: TableProps<T>['rowSelection'];
  loading?: boolean;
  pagination?: TablePaginationConfig;
  onChange?: TableProps<T>['onChange'];
  error?: string | null;
  emptyText?: ReactNode;
  extra?: ReactNode;
  className?: string;
}

const CardTable = <T extends object>({
  title,
  columns,
  dataSource,
  rowKey,
  rowSelection,
  loading = false,
  pagination,
  onChange,
  error,
  emptyText,
  extra,
  className,
}: CardTableProps<T>) => {
  const cardClassName = className ? `${styles.card} ${className}` : styles.card;

  return (
    <div className={cardClassName}>
      <div className={styles.header}>
        <span className={styles.title}>{title}</span>
        <div className={styles.extra}>
          {error ? <span className={styles.errorText}>{error}</span> : null}
          {extra}
        </div>
      </div>
      <div className={styles.wrapper}>
        <Table<T>
          rowKey={rowKey}
          dataSource={dataSource}
          columns={columns}
          loading={loading}
          pagination={pagination}
          onChange={onChange}
          rowSelection={rowSelection}
          locale={{
            emptyText: emptyText || 'No records found.',
          }}
        />
      </div>
    </div>
  );
};

export default CardTable;
